module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 10 6\"><path d=\"M8.372.28L5 3.65 1.628.28A.95.95 0 0 0 .28.28a.952.952 0 0 0 0 1.348l4.046 4.046a.954.954 0 0 0 1.35 0L9.72 1.628A.954.954 0 0 0 8.372.278z\" fill-rule=\"evenodd\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./~/@cian/ui/app/components/icon/icons/arrow.svg
// module id = 874
// module chunks = 0